import { html } from 'lit-html';
import { LitElement, css } from 'lit-element';
import { set_effect_stack } from "../interface_functions.js";

class InsightSwitchBlockSliderTicks extends LitElement {
    static properties = {
        effect_id: { type: String },
        effect_max_stack: { type: Number },
        value: { type: Number },
    };

    static styles = css`
        div.insight_container_switch {
            display: flex;
            align-items: center;
            padding-left: 5px;
            flex-direction: row;
        }

        input[type="range"] {
            -webkit-appearance: none;
            appearance: none;
            /* creating a custom design */
            width: 100%;
            cursor: pointer;
            outline: none;
            border-radius: 15px;
            /*  overflow: hidden;  remove this line*/

            /* New additions */
            height: 6px;
            background: var(--interface-secondary-color);
            margin: 0;
        }

        /* Thumb: webkit */
        input[type="range"]::-webkit-slider-thumb {
            /* removing default appearance */
            -webkit-appearance: none;
            appearance: none;
            /* creating a custom design */
            height: 16px;
            width: 16px;
            background-color: var(--interface-secondary-color);
            border-radius: 50%;
            border: none;

            /* box-shadow: -407px 0 0 400px #f50; emove this line */
            transition: .2s linear;
        }

        /* Thumb: Firefox */
        input[type="range"]::-moz-range-thumb {
            height: 16px;
            width: 16px;
            background-color: var(--interface-secondary-color);
            border-radius: 50%;
            border: none;

            /* box-shadow: -407px 0 0 400px #f50; emove this line */
            transition: .2s linear;
        }

        /* Hover, active & focus Thumb: Webkit */

        input[type="range"]::-webkit-slider-thumb:hover {
            /* box-shadow: 0 0 0 10px rgba(255,85,0, .1)*/
            outline: 2px solid grey;
        }
        input[type="range"]:active::-webkit-slider-thumb {
            /*box-shadow: 0 0 0 13px rgba(255,85,0, .2)*/
            outline: 2px solid grey;
        }

        /* Hover, active & focus Thumb: Firfox */

        input[type="range"]::-moz-range-thumb:hover {
            /*box-shadow: 0 0 0 10px rgba(255,85,0, .1)*/
            outline: 2px solid grey;
        }
        input[type="range"]:active::-moz-range-thumb {
            /*box-shadow: 0 0 0 13px rgba(255,85,0, .2)*/
            outline: 2px solid grey;
        }

        input.stacks_direct {
            width : 45px;
            height : 24px;
            background-color: transparent;
            border: 1px solid var(--interface-secondary-color);
            color: var(--interface-font-color);
            font-size: 16px;
            text-align: center;
            margin: 0px 5px 0px 10px;
            padding: 0;
            -moz-appearance: textfield; /* Firefox */
        }

        input.stacks_direct::-webkit-outer-spin-button,
        input.stacks_direct::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }

        .sliderticks {
            display: flex;
            justify-content: space-between;
            width: 100%;
            box-sizing: border-box;
            padding: 0 8px 0 8px;
        }

        .sliderticks span {
            display: flex;
            justify-content: center;
            width: 1px;
            height: 7px;
            background: #d3d3d3;
            line-height: 40px;
        }
    `;

    handleSliderInput(event) {
        let value = event.target.value;

        // updating rangeInput
        let rangeInput = this.shadowRoot.querySelector("#rangeInput")
        let progress = (parseInt(rangeInput.value) / parseInt(rangeInput.max)) * 100;

        rangeInput.style.background = `linear-gradient(to right, #42b0f5 ${progress}%, white ${progress}%)`;

        // updating numberInput
        let numberInput = this.shadowRoot.querySelector("#numberInput")
        numberInput.value = value;

        set_effect_stack(this.effect_id, value);
    }

    handleNumberInput(event) {

        if (event.target.value == '')
            event.target.value = 0;
        else if (parseInt(event.target.value) > parseInt(event.target.max))
            event.target.value = event.target.max;

        let value = event.target.value;

        // updating rangeInput
        let rangeInput = this.shadowRoot.querySelector("#rangeInput");
        rangeInput.value = value;
        let progress = (parseInt(rangeInput.value) / parseInt(rangeInput.max)) * 100;

        rangeInput.style.background = `linear-gradient(to right, #42b0f5 ${progress}%, white ${progress}%)`;

        set_effect_stack(this.effect_id, value);
    }

    constructor(effect_id, effect_max_stack) {
        super();
        this.effect_id = effect_id; // Значение по умолчанию
        this.effect_max_stack = effect_max_stack;
    }

    render() {
        return html`
            <div class="insight_container_switch">
                <div>
                    <input
                        id="rangeInput"
                        type="range"
                        min='0'
                        value="0"
                        max='${this.effect_max_stack}'
                        @input=${(e) => this.handleSliderInput(e)}
                    />
                    <div class="sliderticks">
                    ${Array(this.effect_max_stack + 1).fill(0).map(() => html`<span></span>`)}
                    </div>
                </div>
                <input
                    id="numberInput"
                    class="stacks_direct"
                    type="number"
                    value="0"
                    min='0'
                    placeholder='-'
                    max='${this.effect_max_stack}'
                    maxlength='3'
                    @input=${(e) => this.handleNumberInput(e)}
                />
            </div>
        `;
    }
}


customElements.define('insight-switch-block-slider-ticks', InsightSwitchBlockSliderTicks);

export function CreateInsightSwitchBlockSliderTicks(effect_id, effect_max_stack)
{
    let InsightSwitchBlock = new InsightSwitchBlockSliderTicks(effect_id, effect_max_stack);

    return InsightSwitchBlock;
}
